module.exports = __webpack_public_path__ + "img/srmm.ade35b94.png";